import React, { useState, useMemo } from 'react';
import { __ } from '@wordpress/i18n';

// store
import { useStoreValue } from '../../store';

// components
import UserAvatar from '../UserAvatar';
import ModalDialog from '../ModalDialog';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';

import './../../assets/components/RecLayerAssignButton.css';

const RecLayerAssignButton = ({
    assignedUser = null,
    onChange
}) => {
    const [modalVisible, setModalVisible] = useState(false);
    const team = useStoreValue('team');

    const teamOptions = useMemo(() => {
        return team.map(member => ({
            ...member,
            label: `${member.name || ''} ${member.surname || ''}`.trim() || member.invitedEmail
        }));
    }, [team]);

    const handleSelect = (member) => {
        onChange?.(member);
        setModalVisible(false);
    };

    return (
        <>
            <div className="recLayerAssign">
                {assignedUser && (
                    <div className="recLayerAssign__avatars">
                        <UserAvatar
                            url={assignedUser.profile_picture_url}
                            name={`${assignedUser.name || ''} ${assignedUser.surname || ''}`.trim()}
                        />
                    </div>
                )}
                {assignedUser
                    ? <button
                        type="button"
                        className="recLayerAssign__addBtn"
                        onClick={() => setModalVisible(true)}
                        aria-label={__('Cambia assegnatario', 'soundbetween')}
                      >+</button>
                    : <button
                        type="button"
                        className="recLayerAssign__addBtn"
                        onClick={() => setModalVisible(true)}
                        aria-label={__('Assegna', 'soundbetween')}
                      >+</button>
                }
            </div>

            {modalVisible && (
                <ModalDialog
                    additionalClasses={['modalCreateProject']}
                    header={__('Seleziona membro', 'soundbetween')}
                    visible={modalVisible}
                    onHide={() => setModalVisible(false)}
                >
                    <div className="recLayerAssignModal__memberList">
                        {teamOptions.length === 0
                            ? <p style={{ color: 'var(--text-color--grey-2)', fontSize: '13px' }}>
                                {__('Nessun membro nel team', 'soundbetween')}
                              </p>
                            : teamOptions.map(member => (
                                <button
                                    key={member.userId}
                                    type="button"
                                    className="recLayerAssignModal__memberItem"
                                    onClick={() => handleSelect(member)}
                                >
                                    <UserAvatar
                                        url={member.profile_picture_url}
                                        name={member.label}
                                    />
                                    <span className="recLayerAssignModal__memberName">
                                        {member.label}
                                    </span>
                                </button>
                            ))
                        }
                    </div>
                    <ButtonFlat size="lg" type="button" onClick={() => setModalVisible(false)}>
                        {__('Annulla', 'soundbetween')}
                    </ButtonFlat>
                </ModalDialog>
            )}
        </>
    );
};

export default RecLayerAssignButton;
